import { Injectable } from '@angular/core';
import { CoreApiService } from 'src/app/core/core-api.service';
import { CodigoTransacaoService } from 'src/app/shared/services/codigo-transacao.service';
import { endpoints } from 'src/environments/endpoints';

@Injectable({
  providedIn: 'root'
})
export class BancoService {

  constructor(private apiService: CoreApiService, private codigo : CodigoTransacaoService) { }


  listarBancos(){
    let params = {codigoTransacao: this.codigo.getUniqueId(5)}
    return this.apiService.get(endpoints.listarBancos, {params})
  }

  listarCorretoras(param){
    let params = {codigoTransacao: this.codigo.getUniqueId(5), idRegime: param}
    return this.apiService.get(endpoints.listarCorretoras, {params})
  }
}
